(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5397],{

/***/ 65397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ CashierModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-qr-code/lib/index.js
var lib = __webpack_require__(1653);
// EXTERNAL MODULE: ./node_modules/stripe-ui/dist/Form/Field.js
var Field = __webpack_require__(84282);
// EXTERNAL MODULE: ./node_modules/stripe-ui/dist/Form/Checkbox.js
var Checkbox = __webpack_require__(75348);
// EXTERNAL MODULE: ./node_modules/stripe-ui/dist/Icon/index.js + 11 modules
var Icon = __webpack_require__(69416);
// EXTERNAL MODULE: ./node_modules/stripe-ui/dist/Button/index.js
var Button = __webpack_require__(74489);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-device-detect/main.js
var main = __webpack_require__(59359);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var react_modal_lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(react_modal_lib);
// EXTERNAL MODULE: ./components/IconPark/index.tsx
var IconPark = __webpack_require__(21826);
// EXTERNAL MODULE: ./components/modal/styles.module.scss
var styles_module = __webpack_require__(45053);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/modal/index.tsx









var modalSizeMapping = {
    large: (styles_module_default()).large,
    small: (styles_module_default()).small,
    medium: (styles_module_default()).medium
};
var Modal = function(props) {
    var children = props.children, _size = props.size, size = _size === void 0 ? "large" : _size, footer = props.footer, title = props.title, onRequestClose = props.onRequestClose, _shouldCloseOnEsc = props.shouldCloseOnEsc, shouldCloseOnEsc = _shouldCloseOnEsc === void 0 ? false : _shouldCloseOnEsc, rest = (0,_object_without_properties/* default */.Z)(props, [
        "children",
        "size",
        "footer",
        "title",
        "onRequestClose",
        "shouldCloseOnEsc"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        ariaHideApp: false,
        overlayClassName: classnames_default()((styles_module_default()).modalOverlay),
        className: classnames_default()((styles_module_default()).modalContent),
        shouldCloseOnEsc: shouldCloseOnEsc,
        closeTimeoutMS: 200,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((styles_module_default()).modal),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("relative h-screen-safe mx-auto md:h-4/5 w-full md:w-auto md:min-w-120 md:max-w-7xl flex flex-col justify-center", modalSizeMapping[size]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white relative h-8 flex-shrink-0 rounded-t",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-bold py-2 text-center",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: onRequestClose,
                                className: "absolute top-1 right-1 cursor-pointer bg-brand p-1 w-6 h-6 flex items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPark/* default */.Z, {
                                    name: "close",
                                    className: classnames_default()("text-white text-lg")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("bg-white p-4 relative flex justify-center overflow-auto max-h-full w-full shadow-inner rounded-b"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-1",
                            children: children
                        })
                    }),
                    footer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).footer,
                        children: footer
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var modal = (Modal);

// EXTERNAL MODULE: ./utils/request.ts + 1 modules
var request = __webpack_require__(85192);
// EXTERNAL MODULE: ./services/payment.ts
var payment = __webpack_require__(42259);
// EXTERNAL MODULE: ./components/Pending/index.tsx
var Pending = __webpack_require__(17266);
// EXTERNAL MODULE: ./components/NavLink/index.tsx
var NavLink = __webpack_require__(31474);
// EXTERNAL MODULE: ./containers/auth.tsx + 4 modules
var auth = __webpack_require__(88156);
// EXTERNAL MODULE: ./services/Utils.ts
var Utils = __webpack_require__(30622);
// EXTERNAL MODULE: ./hooks/useCashier.ts
var useCashier = __webpack_require__(37315);
// EXTERNAL MODULE: ./pages/cashier/layouts/CashierCouponModule.tsx
var CashierCouponModule = __webpack_require__(28320);
// EXTERNAL MODULE: ./components/ImageComponent/index.tsx
var ImageComponent = __webpack_require__(60429);
;// CONCATENATED MODULE: ./utils/protocal-page.ts

function navigatToProtocalPage(classId, gameCategoryCode) {
    var url = getProtocalPageUrl(classId, gameCategoryCode);
    return router.push(url);
}
function getProtocalPageUrl(classId, gameCategoryCode) {
    return "/protocal?cid=".concat(classId || "", "&game=").concat(gameCategoryCode || "");
}

// EXTERNAL MODULE: ./utils/referrerHelper.ts + 1 modules
var referrerHelper = __webpack_require__(26330);
;// CONCATENATED MODULE: ./components/Installment/Option.tsx



var InstallmentOption = function(props) {
    var label = props.label, value = props.value, selected = props.selected, onClick = props.onClick;
    var clickHandler = (0,react.useCallback)(function() {
        if (onClick) {
            onClick(selected ? undefined : value);
        }
    }, [
        onClick,
        selected,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("px-2 py-2 border-2 rounded-lg cursor-pointer text-center", {
            "opacity-50": !selected,
            "border-brand font-bold": selected
        }),
        onClick: clickHandler,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "(免手续费)"
            })
        ]
    });
};
/* harmony default export */ var Option = (InstallmentOption);

;// CONCATENATED MODULE: ./components/Installment/Group.tsx



var InstallmentGroup = function(props) {
    var options = props.options, onChange = props.onChange, _cols = props.cols, cols = _cols === void 0 ? 2 : _cols;
    var ref = (0,react.useState)(), selected = ref[0], setSelected = ref[1];
    var clickHandler = (0,react.useCallback)(function(value) {
        setSelected(value);
    }, []);
    (0,react.useEffect)(function() {
        if (onChange) {
            onChange(selected);
        }
    }, [
        onChange,
        selected
    ]);
    var colClassName = (0,react.useMemo)(function() {
        switch(cols){
            case 1:
                return "grid-cols-1";
            case 2:
                return "grid-cols-2";
            case 3:
                return "grid-cols-3";
            case 4:
                return "grid-cols-4";
        }
    }, [
        cols
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid items-stretch justify-center max-w-lg mx-auto gap-8 ".concat(colClassName),
        children: options.map(function(option, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                label: option.label,
                value: option.value,
                onClick: clickHandler,
                selected: selected === option.value
            }, index);
        })
    });
};
/* harmony default export */ var Group = (InstallmentGroup);

;// CONCATENATED MODULE: ./components/Installment/index.tsx




;// CONCATENATED MODULE: ./components/Modals/CashierModal.tsx
























var paymentVendors = [
    {
        name: "alipay",
        logo: "/images/payment/alipay.png",
        label: "支付宝"
    },
    {
        name: "wechatpay",
        logo: "/images/payment/wechatpay.png",
        label: "微信"
    }, 
];
var initState = {
    vendor: null,
    checkout: false,
    qrcode: null,
    phone_code: "",
    phone_number: "",
    phoneError: false,
    bizId: "",
    aggreedTc: false,
    couponCode: "",
    couponCodeSuccess: true,
    couponCodeError: null,
    showCoupon: false,
    installmentNumber: null
};
function checkoutReducer(state, action) {
    switch(action.type){
        case "set_vendor":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                vendor: action.payload
            });
        case "checkout":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                checkout: true
            });
        case "back":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                checkout: false,
                qrcode: null
            });
        case "set_qrcode":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                qrcode: action.payload
            });
        case "reset":
            return initState;
        case "set_phone":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                phone_number: action.payload
            });
        case "set_phone_code":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                phone_code: action.payload
            });
        case "set_phone_error":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                phoneError: action.payload
            });
        case "set_biz_id":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                bizId: action.payload
            });
        case "aggree_tc":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                aggreedTc: action.payload
            });
        case "set_coupon_code":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                couponCode: action.payload
            });
        case "set_coupon_success":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                couponCodeSuccess: action.payload
            });
        case "set_coupon_error":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                couponCodeError: action.payload
            });
        case "toggle_coupon":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showCoupon: action.payload
            });
        case "set_installment_number":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                installmentNumber: action.payload
            });
        default:
            return state;
    }
}
var CashierModal = function(props) {
    var ref, ref1, ref2, ref3;
    var product = props.product, isOpen = props.isOpen, additionType = props.additionType, additionValue = props.additionValue;
    var ref4 = (0,react.useReducer)(checkoutReducer, initState), state = ref4[0], dispatch = ref4[1];
    var router = (0,next_router.useRouter)();
    var user = (0,auth/* useAuth */.aC)().user;
    var ref5 = (0,useCashier/* useCashier */.I)(product), couponDiscountAmount = ref5.couponDiscountAmount, amount = ref5.amount, checkCoupon = ref5.checkCoupon;
    var payable = (0,react.useMemo)(function() {
        return amount > 0;
    }, [
        amount
    ]);
    var getPaymentQrcode = (0,react.useCallback)(function() {
        var ref;
        dispatch({
            type: "checkout"
        });
        (0,request/* request */.W)({
            url: "/v2/payment/getqrcode/".concat((ref = state.vendor) === null || ref === void 0 ? void 0 : ref.name, "/").concat(product === null || product === void 0 ? void 0 : product.id),
            data: {
                phone_code: state.phone_code,
                phone_number: state.phone_number,
                coupon_code: state.couponCodeSuccess ? state.couponCode : undefined,
                cashier_url: (0,referrerHelper/* appendUtm */.gK)(window.location.href),
                installment_number: state.installmentNumber,
                addition_type: additionType,
                addition_value: additionValue
            },
            method: "post"
        }).then(function(res) {
            if (res.success) {
                dispatch({
                    type: "set_qrcode",
                    payload: res.data.data.url
                });
                dispatch({
                    type: "set_biz_id",
                    payload: res.data.data.biz_id
                });
            } else {
                react_toastify_esm/* toast.error */.Am.error(res.message);
            }
        });
    }, [
        additionType,
        additionValue,
        product === null || product === void 0 ? void 0 : product.id,
        state.couponCode,
        state.couponCodeSuccess,
        state.installmentNumber,
        state.phone_code,
        state.phone_number,
        (ref = state.vendor) === null || ref === void 0 ? void 0 : ref.name, 
    ]);
    var getH5Pay = (0,react.useCallback)(function() {
        var ref;
        (0,request/* request */.W)({
            url: "/v2/payment/h5pay/".concat((ref = state.vendor) === null || ref === void 0 ? void 0 : ref.name, "/").concat(product === null || product === void 0 ? void 0 : product.id),
            data: {
                phone_code: "86",
                phone_number: state.phone_number,
                coupon_code: state.couponCodeSuccess ? state.couponCode : undefined,
                installment_number: state.installmentNumber,
                cashier_url: window.location.href,
                addition_type: additionType,
                addition_value: additionValue
            },
            method: "post"
        }).then(function(res) {
            if (res.success) {
                var ref, ref1;
                if (((ref = state.vendor) === null || ref === void 0 ? void 0 : ref.name) === "wechatpay") {
                    location.href = res.data.data;
                } else if (((ref1 = state.vendor) === null || ref1 === void 0 ? void 0 : ref1.name) === "alipay") {
                    document.write(res.data.data);
                }
            } else {
                react_toastify_esm/* toast.error */.Am.error(res.message);
            }
        });
    }, [
        (ref1 = state.vendor) === null || ref1 === void 0 ? void 0 : ref1.name,
        state.phone_number,
        state.couponCodeSuccess,
        state.couponCode,
        state.installmentNumber,
        product === null || product === void 0 ? void 0 : product.id,
        additionType,
        additionValue, 
    ]);
    var readyToPay = (0,react.useCallback)(function() {
        if (!main/* isMobile */.tq) {
            getPaymentQrcode();
        } else {
            getH5Pay();
        }
    }, [
        getH5Pay,
        getPaymentQrcode
    ]);
    var back = (0,react.useCallback)(function() {
        dispatch({
            type: "back"
        });
    }, []);
    (0,react.useEffect)(function() {
        if (isOpen) {
            dispatch({
                type: "reset"
            });
        }
    }, [
        isOpen
    ]);
    var submitDisabled = (0,react.useMemo)(function() {
        if (!state.aggreedTc) {
            return true;
        }
        return !state.vendor || !state.phone_number;
    }, [
        state.aggreedTc,
        state.phone_number,
        state.vendor
    ]);
    var checkPaymentStatus = (0,react.useCallback)(function() {
        if (state.bizId) {
            (0,payment/* getPaymentStatus */.yv)(state.bizId).then(function(res) {
                if (res.data.data.status !== "Success") {
                    alert("您的订单还未完成支付，请稍后再尝试！");
                    return;
                } else {
                    router.push("/payment-status/?id=".concat(state.bizId));
                }
            }, function(err) {
                alert("订单不存在");
            }).catch(function(exp) {
                alert("订单不存在");
            });
        }
    }, [
        router,
        state.bizId
    ]);
    (0,react.useEffect)(function() {
        if (user && isOpen) {
            dispatch({
                type: "set_phone",
                payload: user.phone_number
            });
            dispatch({
                type: "set_phone_code",
                payload: user.phone_code
            });
        }
    }, [
        isOpen,
        user
    ]);
    (0,react.useEffect)(function() {
        checkCoupon({
            coupon_code: state.couponCode
        });
    }, [
        checkCoupon,
        state.couponCode
    ]);
    var installmentNumber = (0,react.useMemo)(function() {
        if (product) {
            var ref;
            // HOK 价格大于等于1500才能分期
            if (((ref = product.game_category) === null || ref === void 0 ? void 0 : ref.code) === "hok") {
                if (amount < 1500) {
                    return [];
                } else {
                    return [
                        3,
                        6
                    ];
                }
            }
            if ((product === null || product === void 0 ? void 0 : product.time_span_unit) === "Month" && (product === null || product === void 0 ? void 0 : product.time_span)) {
                if ((product === null || product === void 0 ? void 0 : product.time_span) >= 6) {
                    return [
                        3,
                        6
                    ];
                } else if ((product === null || product === void 0 ? void 0 : product.time_span) >= 3) {
                    return [
                        3
                    ];
                }
            } else if ((product === null || product === void 0 ? void 0 : product.time_span_unit) === "Day" && (product === null || product === void 0 ? void 0 : product.time_span)) {
                if ((product === null || product === void 0 ? void 0 : product.time_span) >= 180) {
                    return [
                        3,
                        6
                    ];
                } else if ((product === null || product === void 0 ? void 0 : product.time_span) >= 90) {
                    return [
                        3
                    ];
                }
            }
        }
        return [];
    }, [
        product,
        amount
    ]);
    var installmentOptions = (0,react.useMemo)(function() {
        var ref;
        if (((ref = state.vendor) === null || ref === void 0 ? void 0 : ref.name) === "alipay" && installmentNumber.length) {
            return installmentNumber.map(function(number) {
                return {
                    value: "".concat(number),
                    label: "".concat(Math.floor(amount * 100 / number) / 100, " x ").concat(number, "期")
                };
            });
        }
        return [];
    }, [
        (ref2 = state.vendor) === null || ref2 === void 0 ? void 0 : ref2.name,
        installmentNumber,
        amount
    ]);
    var installmentGroupChangeHandler = (0,react.useCallback)(function(val) {
        if (val) {
            dispatch({
                type: "set_installment_number",
                payload: val
            });
        } else {
            dispatch({
                type: "set_installment_number",
                payload: null
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        size: "small"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pb-4 max-w-lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pending/* Pending */.J, {
                loading: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !state.checkout ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                product && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-xs text-gray-400 mb-2",
                                            children: "您正在购买"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-xl font-bold",
                                            children: product.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-1",
                                            children: product.sub_name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    className: "flex flex-col px-3 my-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-between border-b border-gray-200 py-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-gray-400",
                                                        children: "价格："
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                    children: [
                                                        (0,Utils/* formatCurrency */.xG)(product === null || product === void 0 ? void 0 : product.amount),
                                                        "元"
                                                    ]
                                                })
                                            ]
                                        }),
                                        (product === null || product === void 0 ? void 0 : product.discount_amount) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-between border-b border-gray-200 py-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-gray-400",
                                                        children: "优惠:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                    children: [
                                                        (0,Utils/* formatCurrency */.xG)(product.discount_amount - product.amount),
                                                        "元"
                                                    ]
                                                })
                                            ]
                                        }) : null,
                                        couponDiscountAmount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-between border-b border-gray-200 py-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-gray-400",
                                                        children: "折扣码:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                    children: [
                                                        "-",
                                                        (0,Utils/* formatCurrency */.xG)(couponDiscountAmount),
                                                        "元"
                                                    ]
                                                })
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-between py-2 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-base text-black",
                                                        children: "合计:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-base text-black",
                                                        children: [
                                                            (0,Utils/* formatCurrency */.xG)(amount),
                                                            "元"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                product && /*#__PURE__*/ (0,jsx_runtime.jsx)(CashierCouponModule/* default */.Z, {
                                    onSelect: function(coupon) {
                                        if (coupon) {
                                            dispatch({
                                                type: "set_coupon_code",
                                                payload: coupon.code
                                            });
                                        } else {
                                            dispatch({
                                                type: "set_coupon_code",
                                                payload: undefined
                                            });
                                        }
                                    },
                                    className: "mx-2 mb-3",
                                    product: product
                                }),
                                payable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-[#333] mb-2",
                                            children: "请选择支付方式"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-stretch justify-center max-w-lg mx-auto p-2",
                                            children: paymentVendors.map(function(vendor) {
                                                var ref, ref1;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("flex-1 mx-4 px-2 py-6 border rounded-lg cursor-pointer hover:border-gold-200", ((ref = state.vendor) === null || ref === void 0 ? void 0 : ref.name) !== vendor.name && "opacity-40", ((ref1 = state.vendor) === null || ref1 === void 0 ? void 0 : ref1.name) === vendor.name && "border-gold-400 shadow-md shadow-gold-500"),
                                                    onClick: function() {
                                                        dispatch({
                                                            type: "set_vendor",
                                                            payload: vendor
                                                        });
                                                        if (vendor.name !== "alipay") {
                                                            dispatch({
                                                                type: "set_installment_number",
                                                                payload: null
                                                            });
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageComponent/* default */.Z, {
                                                        alt: vendor.name,
                                                        src: vendor.logo
                                                    })
                                                }, vendor.name);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            className: "py-4 text-left",
                                            children: [
                                                !!(installmentOptions === null || installmentOptions === void 0 ? void 0 : installmentOptions.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* Field */.g, {
                                                    label: "使用花呗分期",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group, {
                                                        options: installmentOptions,
                                                        onChange: installmentGroupChangeHandler
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* Field */.g, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                                                        checkboxProps: {
                                                            id: "agreement",
                                                            checked: state.aggreedTc,
                                                            onChange: function(e) {
                                                                dispatch({
                                                                    type: "aggree_tc",
                                                                    payload: e.target.checked
                                                                });
                                                            }
                                                        },
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text-gray-800",
                                                            children: [
                                                                "我已阅读并同意",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.Z, {
                                                                    href: getProtocalPageUrl(get_default()(product, "class.id", ""), get_default()(product, "game_category.code", "")),
                                                                    target: "_blank",
                                                                    className: "text-gold-500",
                                                                    children: "相关协议"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    className: "text-lg text-black mb-4 text-center",
                                    children: [
                                        "请使用",
                                        (ref3 = state.vendor) === null || ref3 === void 0 ? void 0 : ref3.label,
                                        "扫码支付"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-row justify-center",
                                    children: state.qrcode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inline-block mx-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                            value: state.qrcode,
                                            size: 150
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "my-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                            name: "spin",
                                            size: "large"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center",
                                children: !state.checkout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    variant: "brand",
                                    size: "large",
                                    disabled: submitDisabled,
                                    onClick: readyToPay,
                                    children: "立即支付"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            variant: "base",
                                            size: "large",
                                            onClick: back,
                                            children: "重新选择"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            variant: "brand",
                                            size: "large",
                                            onClick: checkPaymentStatus,
                                            className: "ml-2",
                                            children: "我已完成支付"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    }));
};


/***/ }),

/***/ 37315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useCashier; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72132);
/* harmony import */ var _services_payment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42259);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);







var useCashier = function(product) {
    var initialAmount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return product.discount_amount || product.amount;
    }, [
        product.amount,
        product.discount_amount
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), couponDiscountAmount = ref[0], setCouponDiscountAmount = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), couponRecurringCount = ref1[0], setCouponRecurringCount = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), couponChecking = ref2[0], setCouponChecking = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), couponValid = ref3[0], setCouponVaild = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), discountCode = ref4[0], setDiscountCode = ref4[1];
    var removeCouponDiscount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setCouponDiscountAmount(0);
    }, []);
    var productLocale = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,lodash__WEBPACK_IMPORTED_MODULE_3__.get)(product, "localization.code");
    }, [
        product
    ]);
    var amount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!couponDiscountAmount) {
            return initialAmount;
        } else {
            return initialAmount - couponDiscountAmount < 0 ? 0 : initialAmount - couponDiscountAmount;
        }
    }, [
        couponDiscountAmount,
        initialAmount
    ]);
    // 如果taxable是false，就是免税，否则需要税
    // 那么免税就是taxFreeAmount就是amount，反之taxAmount就是0
    var taxFreeAmount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (product.taxable) {
            return 0;
        } else {
            return amount;
        }
    }, [
        product.taxable,
        amount
    ]);
    var vat = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (product.taxable) {
            var grossAmount = Math.round((amount - taxFreeAmount) / 1.1);
            var vat = amount - taxFreeAmount - grossAmount;
            return vat;
        } else {
            return 0;
        }
    }, [
        amount,
        product.taxable,
        taxFreeAmount
    ]);
    /**
   * 如果是false则为通过，否则返回错误信息
   */ var checkPromoCode = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(promoCode) {
            var res, ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_services_payment__WEBPACK_IMPORTED_MODULE_2__/* .checkPromoCodeApi */ .Pn)(product.id, promoCode)
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.success) {
                            ;
                            setCouponDiscountAmount(res.data.data.coupon_discount || res.data.data.promo_discount);
                            setCouponRecurringCount(((ref = res.data.data.coupon) === null || ref === void 0 ? void 0 : ref.recurring_count) || 1);
                            setCouponVaild(promoCode ? "valid" : undefined);
                            setDiscountCode({
                                promo_code: promoCode
                            });
                            return [
                                2,
                                false
                            ];
                        } else {
                            return [
                                2,
                                res.message
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(promoCode) {
            return _ref.apply(this, arguments);
        };
    }(), [
        product.id
    ]);
    var checkCoupon = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(context) {
            var res, ref, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(context === null || context === void 0 ? void 0 : context.coupon_code) && !(context === null || context === void 0 ? void 0 : context.promo_code)) {
                            removeCouponDiscount();
                            setCouponVaild(undefined);
                            setDiscountCode({});
                            return [
                                2,
                                true
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setCouponVaild(undefined);
                        setDiscountCode({});
                        setCouponChecking(true);
                        return [
                            4,
                            (0,_services_payment__WEBPACK_IMPORTED_MODULE_2__/* .calculateProductAmountAPI */ .Te)(product.id, context)
                        ];
                    case 2:
                        res = _state.sent();
                        if (res.success) {
                            ;
                            setCouponDiscountAmount(res.data.data.coupon_discount || res.data.data.promo_discount);
                            setCouponRecurringCount(((ref = res.data.data.coupon) === null || ref === void 0 ? void 0 : ref.recurring_count) || 1);
                            setCouponVaild("valid");
                            setDiscountCode((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, context));
                            return [
                                2,
                                true
                            ];
                        } else {
                            setCouponVaild("invalid");
                            setDiscountCode({});
                            removeCouponDiscount();
                            react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .Am.error(res.message);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        removeCouponDiscount();
                        setCouponVaild("invalid");
                        setDiscountCode({});
                        return [
                            2,
                            "coupon code error"
                        ];
                    case 4:
                        setCouponChecking(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(context) {
            return _ref.apply(this, arguments);
        };
    }(), [
        product.id,
        removeCouponDiscount
    ]);
    return {
        initialAmount: initialAmount,
        removeCoupontDiscount: removeCouponDiscount,
        amount: amount,
        couponDiscountAmount: couponDiscountAmount,
        checkCoupon: checkCoupon,
        discountCode: discountCode,
        couponValid: couponValid,
        couponRecurringCount: couponRecurringCount,
        taxFreeAmount: taxFreeAmount,
        vat: vat,
        couponChecking: couponChecking,
        checkPromoCode: checkPromoCode,
        productLocale: productLocale
    };
};


/***/ }),

/***/ 28320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CashierCouponModule; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var stripe_ui__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69416);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2031);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13877);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50888);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24405);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47318);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85192);
/* harmony import */ var _containers_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88156);
/* harmony import */ var _components_IconPark__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21826);













function CouponList(param) {
    var list = param.list, onSelect = param.onSelect;
    var ref = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)("buynow"), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), current = ref1[0], setCurrent = ref1[1];
    var unit = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return i18n.language === "kr" ? "₩" : "￥";
    }, [
        i18n.language
    ]);
    var couponItem = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(item) {
        var discount = item.discount, recurring_count = item.recurring_count, expired_at = item.expired_at, code = item.code, coupon_type = item.coupon_type;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: function() {
                if (current && current.code === code) {
                    setCurrent(undefined);
                    onSelect();
                } else {
                    setCurrent(item);
                    onSelect(item);
                }
            },
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-full transition-all outline ease-in-out cursor-pointer rounded-md py-1 px-3 border border-gray-400 bg-gray-300 hover:border-gold-400 hover:bg-gold-50 text-white hover:text-gold-500", current && current.code === code ? "outline-gold-400 border-gold-400 bg-gold-50 text-gold-600" : "outline-transparent"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-xs text-left",
                    children: code
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex space-x-3 items-end",
                    children: [
                        coupon_type === "Discount" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex-1 text-left",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-3xl font-fjalla",
                                    children: discount
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-sm",
                                    children: "% Off"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex-1 text-left",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-base",
                                    children: unit
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-3xl font-fjalla",
                                    children: discount
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-1/2 text-right",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        t("coupon-valid-until"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(new Date(expired_at), "yyyy-MM-dd")
                                })
                            ]
                        })
                    ]
                })
            ]
        }, item.code);
    }, [
        current,
        onSelect,
        t,
        unit
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "overflow-auto max-h-48 px-1 py-1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "space-y-2",
            children: list && list.map(function(item) {
                return couponItem(item);
            })
        })
    });
}
function EmptyCouponList() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)("buynow").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_IconPark__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "text-[#333] text-5xl m-3",
                name: "noresult"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-[#333]",
                children: t("no_coupons_found")
            })
        ]
    });
}
function CashierCouponModule(param) {
    var product = param.product, className = param.className, onSelect = param.onSelect;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), showCoupons = ref[0], setShowCoupons = ref[1];
    var isAuthenticated = (0,_containers_auth__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)().isAuthenticated;
    var ref1 = (0,ahooks__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        return (0,_utils_request__WEBPACK_IMPORTED_MODULE_4__/* .request */ .W)({
            url: "/v2/product/getcoupons/".concat(product.id)
        });
    }, {
        manual: true
    }), data = ref1.data, loading = ref1.loading, run = ref1.run;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)("buynow").t;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isAuthenticated && showCoupons) {
            run();
        }
    }, [
        isAuthenticated,
        run,
        showCoupons
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: "#",
                    onClick: function(e) {
                        e.preventDefault();
                        var res = !showCoupons;
                        if (!res) {
                            onSelect(undefined);
                        }
                        setShowCoupons(res);
                    },
                    className: "no-underline flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: t("i_have_coupon")
                        }),
                        loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            className: "ml-4 text-xs"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(stripe_ui__WEBPACK_IMPORTED_MODULE_11__/* .Icon */ .J, {
                            name: "chevronRight",
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline-block ml-0.5", {
                                "rotate-90 transform": showCoupons
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_12__/* .Transition */ .u, {
                show: showCoupons && !loading,
                enter: "transition-opacity ease-linear duration-300",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "transition-opacity ease-linear duration-300",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: (0,lodash__WEBPACK_IMPORTED_MODULE_3__.get)(data, "data.data.length") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CouponList, {
                    onSelect: function(coupon) {
                        onSelect(coupon);
                    },
                    list: (0,lodash__WEBPACK_IMPORTED_MODULE_3__.get)(data, "data.data")
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmptyCouponList, {})
            })
        ]
    });
}


/***/ }),

/***/ 45053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal-overlay":"styles_modal-overlay__1txQb","modalOverlay":"styles_modal-overlay__1txQb","modal-content":"styles_modal-content__uqIT8","modalContent":"styles_modal-content__uqIT8","modal":"styles_modal__bl0hC","body":"styles_body__Top_V","footer":"styles_footer__sNiBc","close":"styles_close__gBWEt"};

/***/ })

}]);